import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { MenuItemEnum, SidebarModelResponse } from 'src/models/Partner/Sidebar';
import { currentUserSelector } from 'src/store/user/selectors';
import {
  getMenuItem,
  getMenuItems,
  MenuItemProps,
  sideBarGlobalItemsIds,
  sideBarSettingsItemsIds,
} from '../helpers/links';

type StaticMenuItemsType = {
  global: MenuItemProps[];
  settings: MenuItemProps[];
  startGuideItem: MenuItemProps | null;
  administrationItem: MenuItemProps | null;
  partnerAdministrationItem: MenuItemProps | null;
  pledgeFundingItem: MenuItemProps | null;
  switchOrganization: MenuItemProps | null;
};

export const useStaticMenuItems = (allItems: SidebarModelResponse['MenuItems'] | undefined) => {
  const initialState: StaticMenuItemsType = {
    global: [],
    settings: [],
    startGuideItem: null,
    administrationItem: null,
    partnerAdministrationItem: null,
    pledgeFundingItem: null,
    switchOrganization: null,
  };

  const [staticMenuItems, setStaticMenuItems] = useState<StaticMenuItemsType>(initialState);

  const userModel = useSelector(currentUserSelector);

  const organizationId = userModel.response?.organizationInfo.OrganizationUrl || '';

  useEffect(() => {
    if (!allItems) {
      setStaticMenuItems(initialState);
    } else {
      setStaticMenuItems({
        global: getMenuItems(sideBarGlobalItemsIds, allItems, organizationId),
        settings: getMenuItems(sideBarSettingsItemsIds, allItems, organizationId),
        startGuideItem: getMenuItem(MenuItemEnum.StartGuide, allItems, organizationId),
        administrationItem: getMenuItem(MenuItemEnum.Administration, allItems, organizationId),
        partnerAdministrationItem: getMenuItem(MenuItemEnum.PartnerAdministration, allItems, organizationId),
        pledgeFundingItem: getMenuItem(MenuItemEnum.PledgeFunding, allItems, organizationId),
        switchOrganization: getMenuItem(MenuItemEnum.SwitchAccount, allItems, organizationId),
      });
    }
    // eslint-disable-next-line
  }, [allItems, organizationId]);

  return staticMenuItems;
};
